module.exports = __webpack_public_path__ + "media/application/images/projects/images/oman-ae3631a50f49467a303c8c2b20895ca3.jpg";